// extracted by mini-css-extract-plugin
export default {"loading":"Page-module_loading_e5153e"};